import { workspaceVar } from './variables';

export function setWorkspace(newValue) {
    workspaceVar(newValue);
}
